import { CreateOrderRequest, OrderDiscount } from '@models/order';
import { PayloadAction, WritableDraft } from '@reduxjs/toolkit';

// 특정 쿠폰 ID 하나만 제거 (토글 시 먼저 호출하여 기존 상태 초기화)
export function removeCoupon(
    state: WritableDraft<CreateOrderRequest>,
    action: PayloadAction<string>,
) {
    state.discounts = state.discounts?.filter((d) => d.couponId !== action.payload);
}

// COUPON 타입 전체 제거 (포인트 등 다른 타입의 할인은 유지)
export function clearCoupons(state: WritableDraft<CreateOrderRequest>, _: PayloadAction) {
    state.discounts = state.discounts?.filter((d) => d.type !== 'COUPON');
}

// 전달된 배열로 discounts를 교체
// 임직원 할인은 useEmployeeDiscount 플래그에서 파생 계산되는 값이므로 스토어에 저장하지 않는다.
// (파생 결과를 그대로 dispatch할 경우 해제 후에도 할인이 남는 것을 방지)
export function setDiscounts(
    state: WritableDraft<CreateOrderRequest>,
    action: PayloadAction<OrderDiscount[]>,
) {
    state.discounts = action.payload.filter((d) => d.type !== 'EMPLOYEE');
}

export function clearDiscounts(state: WritableDraft<CreateOrderRequest>) {
    state.discounts = [];
    state.prepaidCardPayments = [];
    state.giftPayments = [];
    state.useEmployeeDiscount = false;
}

// 포인트 사용 금액 설정. 0이면 포인트 사용을 해제한다
export function setPointDiscount(
    state: WritableDraft<CreateOrderRequest>,
    action: PayloadAction<number>,
) {
    const others = state.discounts?.filter((d) => d.type !== 'POINT') || [];
    state.discounts = action.payload > 0 ? [...others, {
        type: 'POINT',
        discountScope: 'ORDER',
        discountMethod: 'FIXED',
        discountAmount: action.payload,
    }] : others;
}
